/**
 * @module components/Form/FormGroupSiteDesignation
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Form group for getting site designation
 */

import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton, HelpBlock } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import { useAppState } from '../../contexts/app-state-provider';


type Props = {
  value: string,
  code: string,
  onChange: React.FormEventHandler<ToggleButton>
}


/**
 * React component
 * ===============
 */
const FormGroupSiteDesignation = ({
  value,
  code,
  onChange
}: Props) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();

  return (
    <Row className='form-group'>
      <Col sm={2} className='control-label' style={{fontWeight:700}}>
        {lang.form.siteDesignation}
      </Col>
      <Col sm={10}>
        <ButtonToolbar>
          <ToggleButtonGroup
            type="radio"
            name="siteDesignation"
            value={value}
            onChange={() => {}} // suppress warning
          >
            {state.form.siteDesignations.map((v, i) => (
              <ToggleButton key={i} value={v} onChange={onChange}>
                {(v in lang.form.siteDesginationLabels)?lang.form.siteDesginationLabels[v]:v}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </ButtonToolbar>
        { (code in lang.form.siteDesignationHelpMap) &&
          <HelpBlock>{lang.form.siteDesignationHelpMap[code]}</HelpBlock>
        }
      </Col>
    </Row>
  );
}

export default FormGroupSiteDesignation;
